const mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
export {
  mirrorEasing
};
//# sourceMappingURL=mirror.js.map
